import React from 'react';
import { Box, Grid } from '@mui/material';
import SectionHeader from './SectionHeader';
import ProjectProgressChart from './ProjectProgressChart';
import ProjectStatusDistribution from './ProjectStatusDistribution';
import TasksToday from './TasksToday';
import CurrentProject from './CurrentProject';
import { t } from '../../../utils/textUtils';

const DashboardOverviewSection = ({
  selectedProject,
  handleFilterChange,
  dashboardOverviewData,
  activeProjects,
  projects,
  statusCounts,
  todayTasks,
  displayName,
  statusColors,
  getProgressColor
}) => {
  return (
    <Grid container spacing={3} sx={{ mt: 3 }}>
      {/* DASHBOARD OVERVIEW Section */}
      <Grid size={12}>
        <SectionHeader
          title={t('TINJAUAN DASBOR')}
          subtitle={t('Ringkasan progres dan status proyek yang sedang berjalan.')}
        />
        
        {/* Menggunakan CSS Grid Layout untuk Dashboard Overview */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(2, 1fr)'
          },
          gap: 3,
          mb: 3
        }}>
          <ProjectProgressChart 
            selectedProject={selectedProject}
            handleFilterChange={handleFilterChange}
            dashboardOverviewData={dashboardOverviewData}
            activeProjects={activeProjects}
          />
          
          <ProjectStatusDistribution 
            projects={projects}
            dashboardOverviewData={dashboardOverviewData}
            statusCounts={statusCounts}
          />
        </Box>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(2, 1fr)'
          },
          gap: 3,
          mb: 3
        }}>
          <TasksToday 
            dashboardOverviewData={dashboardOverviewData}
            todayTasks={todayTasks}
          />
          
          <CurrentProject 
            dashboardOverviewData={dashboardOverviewData}
            activeProjects={activeProjects}
            displayName={displayName}
            statusColors={statusColors}
            getProgressColor={getProgressColor}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardOverviewSection;
